



import Page from '../PostSales/sale/teskManage.vue'
export default {
  name: 'teskManageRD',
  components: { Page },
}
